export const repeats = [
  { name: $localize`Weekly`, value: 1 },
  { name: $localize`Monthly`, value: 2 },
  { name: $localize`Yearly`, value: 3 },
]

export const statuses = [
  { name: $localize`Paid`, value: 2 },
  { name: $localize`Unpaid`, value: 1 },
]

export const methods = [
  { name: $localize`Bank Deposit`, value: 'bankdeposit' },
  { name: $localize`Card`, value: 'card' },
  { name: $localize`Cash`, value: 'cash' },
  { name: $localize`Check`, value: 'check' },
  { name: $localize`Credit`, value: 'credit' },
  { name: $localize`Wire Transfer`, value: 'wiretransfer' },
  { name: $localize`Other`, value: 'other' },
]

export const categories = [
  { name: $localize`Swimming`, value: 'Swimming' },
  { name: $localize`Garden`, value: 'Garden' },
  { name: $localize`Maintenance`, value: 'Maintenance' },
  { name: $localize`Room Cleaning`, value: 'Room Cleaning' },
  { name: $localize`Food`, value: 'Food' },
  { name: $localize`Portal`, value: 'Portal' },
  { name: $localize`Transportation`, value: 'Transportation' },
  { name: $localize`Other`, value: 'Other' },
]

export function getExtraMethod(method: string): string {
  return methods.find((t) => t.value === method)?.name || $localize`Unknown`
}

export function getExtraStatus(status: number) {
  return statuses.find((t) => t.value == status)?.name
}
